import { add } from './add';
import { clear } from './clear';
import { clearDocs } from './clearDocs';
import { createInstance } from './createInstance';
import { find } from './find';
import { findEarliest } from './findEarliest';
import { findById } from './findById';
import { remove } from './remove';
import { removeInstanceFromSeries } from './removeInstanceFromSeries';
import { search } from './search';
import { searchUnderwriters } from './searchUnderwriters';
import { setReturnPageAfterAddDeleteActions } from './setReturnPageAfterAddDeleteActions';
import { update } from './update';

export const trafficActions = {
  add,
  clear,
  clearDocs,
  createInstance,
  find,
  findById,
  findEarliest,
  remove,
  removeInstanceFromSeries,
  search,
  searchUnderwriters,
  setReturnPageAfterAddDeleteActions,
  update,
};
